/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetTwinMapOptionsEditor.vue?vue&type=template&id=20b2a373&scoped=true"
import script from "./widgetTwinMapOptionsEditor.vue?vue&type=script&lang=js"
export * from "./widgetTwinMapOptionsEditor.vue?vue&type=script&lang=js"
import style0 from "./widgetTwinMapOptionsEditor.vue?vue&type=style&index=0&id=20b2a373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b2a373",
  null
  
)

export default component.exports